module.exports = __webpack_public_path__ + "static/img/lun3.467fcab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lun3.jpg
// module id = +jvI
// module chunks = 1